<template>
  <div :ref="chartRefId" :style="{ width: '100%', height: '400px' }"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'LineChartFromObjects',
  props: {
    dataInput: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      chartRefId: `chart-${this._uid}`,
      chartInstance: null
    };
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      const chartEl = this.$refs[this.chartRefId];
      if (!chartEl) return;

      this.chartInstance = echarts.init(chartEl);

      const labels = this.dataInput.map(item => item.variable);
      const values = this.dataInput.map(item => Number(item.value));

      const options = {
        title: {
          text: 'Line Chart from Object Data'
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: labels
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: 'Value',
            type: 'line',
            data: values,
            lineStyle: {
              color: '#FFD38A'
            },
            itemStyle: {
              color: '#D47900'
            }
          }
        ]
      };

      this.chartInstance.setOption(options);

      window.addEventListener('resize', this.resizeChart);
    },
    resizeChart() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },
    getChartInstance() {
      return this.chartInstance;
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.resizeChart);
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  }
};
</script>
